import React from 'react';
import { Box, Center } from '@chakra-ui/core';
import VideoPlayer from './VideoPlayer';

const PlayIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 5.5L15 10L7 14.5V5.5Z" fill="#3182CE" />
  </svg>
);

export const VideoTrigger: React.FC<{ src: string }> = ({ src }) => (
  <Box
    borderRadius="10px"
    overflow="hidden"
    bg="#3d5a6b"
    width="28vw"
    minW="180px"
    maxW="320px"
    cursor="pointer"
    position="relative"
    style={{
      aspectRatio: '16 / 9',
    }}
    _hover={{ opacity: 0.93 }}
    transition="opacity 0.15s"
  >
    <VideoPlayer
      src={src}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
        pointerEvents: 'none',
      }}
      preload="metadata"
    />

    <Box
      position="absolute"
      inset={0}
      style={{
        background: 'rgba(30, 55, 70, 0.35)',
      }}
    />

    <Center position="absolute" inset={0}>
      <Box
        bg="white"
        borderRadius="full"
        width="44px"
        height="44px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="0 2px 12px rgba(0,0,0,0.25)"
      >
        <PlayIcon />
      </Box>
    </Center>
  </Box>
);
